export const generativeAiAgentIdLogsCallingLocations = "/generative_ai/agent/:id/logs/calling_locations";
